import { get, post, serialize } from '../httpClient';

export const wherebyAPI = {
  createMeeting: body => post('/api/whereby/create-meeting', serialize(body)),
  getMeeting: params => get('/api/whereby/get-meeting', params),
  // Event meeting rooms (org: permission-gated; creator: self-scoped).
  createMeetingForOrg: (orgId, body) =>
    post(`/api/org/${orgId}/whereby/create-meeting`, serialize(body)),
  createMeetingForCreator: body =>
    post('/api/creator/whereby/create-meeting', serialize(body)),
};